import { cloneDeep } from 'lodash';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const ID_KEY_NAMES = ['_uid', 'id', 'uuid', 'group_id'];
const REFERENCE = '_reference';
const BREADCRUMBS = 'breadcrumbs';

const isUUID = value => UUID_REGEX.test(value);

const isRelation = (value, key) =>
  typeof value === 'string' && isUUID(value) && !ID_KEY_NAMES.includes(key);

const isReference = value => value.component?.endsWith(REFERENCE);

const createReference = value => {
  const componentName = value.component.split(REFERENCE)[0];
  const newContent = value[componentName]?.content || value[componentName];
  return { ...newContent };
};

const getBreadcrumbs = async (fullSlug, getLinks) => {
  let path = [];
  const breadcrumbs = await Promise.all(
    fullSlug.split('/').map(async (slug, index) => {
      path[index] = index === 0 ? slug : `${path[index - 1]}/${slug}`;
      const links = await Object.entries(await getLinks(path[index]));
      const item = await links.find(item => item[1].slug === path[index]);
      return { title: item[1]?.name, url: item[1]?.real_path };
    }),
  );
  return breadcrumbs.filter(item => item.url);
};

const findRelations = async (fullSlug, obj, fn, getLinks) => {
  if (obj?.component === BREADCRUMBS) {
    obj.list_path = await getBreadcrumbs(fullSlug, getLinks);
    return;
  }
  for (let key in obj) {
    const value = obj[key];
    if (value && typeof value === 'object') {
      await findRelations(fullSlug, value, fn, getLinks);
      if (isReference(value)) {
        obj[key] = createReference(value);
      }
    } else if (isRelation(value, key)) {
      obj[key] = await fn(value);
      await findRelations(fullSlug, obj, fn, getLinks);
    }
  }
};

export const resolveRelations = async (fullSlug, obj, fn, getLinks) => {
  const result = cloneDeep(obj);
  await findRelations(fullSlug, result, fn, getLinks);
  return result;
};
